var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 7.11663V8.10834C11.6665 9.94584 10.6165 10.7333 9.0415 10.7333H3.7915C2.2165 10.7333 1.1665 9.94584 1.1665 8.10834V4.95833C1.1665 3.12083 2.2165 2.33333 3.7915 2.33333H5.3665C5.29067 2.55499 5.24984 2.79999 5.24984 3.06249V5.33751C5.24984 5.90334 5.4365 6.38167 5.769 6.71417C6.1015 7.04667 6.57984 7.23334 7.14567 7.23334V8.04418C7.14567 8.34168 7.484 8.52247 7.73484 8.35914L9.42067 7.23334H10.9373C11.1998 7.23334 11.4448 7.19247 11.6665 7.11663Z",
    stroke: "#353131",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 3.06251V5.33752C12.8333 6.20669 12.39 6.85998 11.6667 7.11664C11.445 7.19248 11.2 7.23335 10.9375 7.23335H9.42083L7.735 8.35915C7.48417 8.52248 7.14583 8.34169 7.14583 8.04419V7.23335C6.58 7.23335 6.10167 7.04668 5.76917 6.71418C5.43667 6.38168 5.25 5.90335 5.25 5.33752V3.06251C5.25 2.80001 5.29083 2.55501 5.36667 2.33334C5.62333 1.61001 6.27667 1.16667 7.14583 1.16667H10.9375C12.075 1.16667 12.8333 1.92501 12.8333 3.06251Z",
    stroke: "#353131",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31641 12.8333H8.51641",
    stroke: "#353131",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 10.7334V12.8333",
    stroke: "#353131",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.789 4.22917H10.7943",
    stroke: "#353131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15574 4.22917H9.16099",
    stroke: "#353131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52244 4.22917H7.52769",
    stroke: "#353131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8954a59712a42998b832e10f62ce08b7.svg";
export { ForwardRef as ReactComponent };